"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = isArray;
exports.isEmpty = isEmpty;
exports.default = void 0;

function isArray(value) {
  return value instanceof Array;
}

function isEmpty(array) {
  return typeof array === 'undefined' || array === null || array.length === 0;
}

var arrayUtils = {
  isArray: isArray,
  isEmpty: isEmpty
};
var _default = arrayUtils;
exports.default = _default;
//# sourceMappingURL=arrays.js.map